import { ArrowDown } from "lucide-react";
import { IMAGES } from "../data/content";
import { Reveal } from "../components/Reveal";
import { scrollToTarget } from "../lib/scroll";

const STATS = [
  { value: "+15", label: "Años de experiencia" },
  { value: "PRO", label: "Culturista natural" },
  { value: "OCB", label: "Co-fundador OCB Spain" },
];

const About = () => (
  <section id="sobre-mi" data-testid="rnb-about-section" className="py-20 lg:py-32 bg-[#050505]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <Reveal className="">
          <p className="text-xs tracking-[0.4em] text-zinc-500 uppercase">Acerca de mí</p>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95]">
            HOLA, SOY DANI POSTIGO
          </h2>
          <p className="mt-6 text-base sm:text-lg text-zinc-400 font-light leading-relaxed">
            Llevo más de 15 años en el mundo del fitness, primero como atleta y después ayudando a otros a
            transformar su físico. Soy culturista profesional natural y co-fundador de OCB Spain, así que todo lo
            que te enseño lo aplico primero en mí.
          </p>
          <p className="mt-4 text-base sm:text-lg text-zinc-400 font-light leading-relaxed">
            Sé lo que es querer cambiar tu cuerpo con trabajo, estrés y poco tiempo. Por eso mi método no va de
            vivir en el gimnasio, sino de hacer bien lo importante, sin atajos.
          </p>
          <div className="mt-10 grid grid-cols-3 gap-4">
            {STATS.map((s) => (
              <div key={s.label} className="border border-zinc-800 bg-[#0D0D0D] p-4 text-center">
                <p className="font-display text-3xl sm:text-4xl text-white">{s.value}</p>
                <p className="mt-1 text-[10px] tracking-[0.15em] text-zinc-500 uppercase leading-tight">{s.label}</p>
              </div>
            ))}
          </div>
          <button
            onClick={() => scrollToTarget("#coaching-vip")}
            data-testid="rnb-about-cta-cambia-tu-vida"
            className="group mt-10 hidden lg:inline-flex items-center gap-3 bg-white text-black font-display text-xl tracking-[0.15em] px-8 py-4 hover:bg-zinc-200 transition-colors"
          >
            CAMBIA TU VIDA
            <ArrowDown className="h-5 w-5 transition-transform duration-300 group-hover:translate-y-1" />
          </button>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="overflow-hidden border border-zinc-800">
            <img
              src={IMAGES.about}
              alt="Dani Postigo"
              data-testid="rnb-dani-postigo-image"
              loading="lazy"
              className="w-full h-auto"
            />
          </div>
        </Reveal>
        <Reveal delay={0.2} className="lg:hidden">
          <button
            onClick={() => scrollToTarget("#coaching-vip")}
            data-testid="rnb-about-cta-cambia-tu-vida-mobile"
            className="group mt-2 inline-flex items-center gap-3 bg-white text-black font-display text-xl tracking-[0.15em] px-8 py-4 hover:bg-zinc-200 transition-colors w-full justify-center"
          >
            CAMBIA TU VIDA
            <ArrowDown className="h-5 w-5 transition-transform duration-300 group-hover:translate-y-1" />
          </button>
        </Reveal>
      </div>
    </div>
  </section>
);

export default About;
